export const TEXT_COLORS = {
  contrastText: 'contrastText',
  textPrimary: 'textPrimary',
};

export const TEXT_FORMATS = {
  headerOne: 'headerOne',
  headerTwo: 'headerTwo',
  headerThree: 'headerThree',
  body: 'body',
  caption: 'caption',
  code: 'code',
};
